export class Location {
  textNodes = null

  constructor(root) {
    this.root = root
  }

  findTexts() {
    if (!this.textNodes) {
      this.textNodes = new Map()
      this.walkTreeNodes(this.root, ({ node, nodeValue }) =>
        this.textNodes.set(node, nodeValue)
      )
    }
    return Array.from(this.textNodes.values())
  }

  walkTreeNodes(node, callback) {
    if (
      (node.dataset && 'doNotTranslate' in node.dataset) ||
      node.nodeName.toUpperCase() === 'STYLE' ||
      node.nodeName.toUpperCase() === 'SCRIPT' ||
      node.nodeName.toUpperCase() === 'NOSCRIPT' ||
      node.nodeName.toUpperCase() === 'SVG'
    ) {
      return
    }
    if (node.nodeName === '#text') {
      const nodeValue = node.nodeValue.trim()
      const needsTranlation = nodeValue?.match(/[A-Za-z]/)
      if (needsTranlation) {
        callback({ node, nodeValue })
      }
      return
    }
    if (node.placeholder) {
      const nodeValue = node.placeholder.trim()
      const needsTranlation = nodeValue?.match(/[A-Za-z]/)
      if (needsTranlation) {
        callback({ node, nodeValue })
      }
      return
    }
    node.childNodes.forEach(childNode => {
      this.walkTreeNodes(childNode, callback)
    })
  }

  setTranslations(translations) {
    if (this.textNodes) {
      let i = 0
      for (const node of this.textNodes.keys()) {
        if (node.nodeName === '#text') {
          node.nodeValue = translations[i]
        } else if (node.placeholder) {
          node.placeholder = translations[i]
        }
        i++
      }
    }
  }

  revert() {
    if (this.textNodes) {
      for (const [node, originalText] of this.textNodes.entries()) {
        if (node.nodeName === '#text') {
          node.nodeValue = originalText
        } else if (node.placeholder) {
          node.placeholder = originalText
        }
      }
    }
  }
}
